/**
 * Local Storage Service
 * Handles all localStorage operations with error handling
 */

/**
 * Get data from localStorage
 * @param {string} key - The key to retrieve
 * @returns {string|null} - The stored value or null
 */
export const getStoredData = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error(`Error reading from localStorage (${key}):`, error);
    return null;
  }
};

/**
 * Set data in localStorage
 * @param {string} key - The key to store
 * @param {string} value - The value to store
 * @returns {boolean} - Success status
 */
export const setStoredData = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.error(`Error writing to localStorage (${key}):`, error);
    return false;
  }
};

/**
 * Remove data from localStorage
 * @param {string} key - The key to remove
 * @returns {boolean} - Success status
 */
export const removeStoredData = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.error(`Error removing from localStorage (${key}):`, error);
    return false;
  }
};

/**
 * Clear all localStorage data
 * @returns {boolean} - Success status
 */
export const clearAllStoredData = () => {
  try {
    localStorage.clear();
    return true;
  } catch (error) {
    console.error('Error clearing localStorage:', error);
    return false;
  }
};
